
import { Component } from 'vue-property-decorator';
import LastSync from '@/components/LastSync.vue';
import BaseReport from '../../BaseReport.vue';
import userx from '@/store/modules/userx';
import router from '@/router';
import TitleBar from '@/components/reports-v3/pages/dashboard/TitleBar.vue';
import StickyFilterContainer from '@/components/reports-v3/components/pages/StickyFilterContainer.vue';
import TodaySalesNumberDisplayer from '@/components/reports-v3/components/codedWidgets/dashboard/DashboardSalesNumberDisplayer.vue';
import TodayProfitNumberDisplayer from '@/components/reports-v3/components/codedWidgets/dashboard/DashboardEstimateProfitNumberDisplayer.vue';
import TodayQuotationNumberDisplayer from '@/components/reports-v3/components/codedWidgets/dashboard/DashboardQuotationNumberDisplayer.vue';
import SalesAgentRankingTable from '@/components/reports-v3/components/codedWidgets/dashboard/DashboardSalesAgentRankingTable.vue';
import SalesCustomerRankingTable from '@/components/reports-v3/components/codedWidgets/dashboard/DashboardSalesCustomerRankingTable.vue';
import DateFilter from '@/components/reports-v3/components/filters/DateFilter.vue';
import moment from 'moment';
import gdbx from '@/store/modules/gdbx';
import SalesInvoiceCreditNoteLineChart from '@/components/reports-v3/components/codedWidgets/dashboard/DashboardCurrentMonthSalesLineChart.vue';
import QuotationLineChart from '@/components/reports-v3/components/codedWidgets/dashboard/DashboardCurrentMonthQuotationLineChart.vue';
import CashOnHandDisplayer from '@/components/reports-v3/components/codedWidgets/dashboard/DashboardCashOnHandDisplayer.vue';
import CashInBankDisplayer from '@/components/reports-v3/components/codedWidgets/dashboard/DashboardCashInBankDisplayer.vue';
import CashFlowDisplayer from '@/components/reports-v3/components/codedWidgets/dashboard/DashboardNetCashFlowNumberDisplayer.vue';
import CashInDisplayer from '@/components/reports-v3/components/codedWidgets/dashboard/DashboardCashInFlowNumberDisplayer.vue';
import CashOutDisplayer from '@/components/reports-v3/components/codedWidgets/dashboard/DashboardCashOutFlowNumberDisplayer.vue';
import TodayCustomerDueTable from '@/components/reports-v3/components/codedWidgets/dashboard/DashboardCustomerDueTable.vue';
import TodaySupplierDueTable from '@/components/reports-v3/components/codedWidgets/dashboard/DashboardSupplierDueTable.vue';
import accountx from '@/store/modules/accountx';

@Component({
	components: {
		LastSync,
		TitleBar,
		TodaySalesNumberDisplayer,
		TodayProfitNumberDisplayer,
		TodayQuotationNumberDisplayer,
		StickyFilterContainer,
		DateFilter,
		SalesAgentRankingTable,
		SalesCustomerRankingTable,
		SalesInvoiceCreditNoteLineChart,
		QuotationLineChart,
		CashOnHandDisplayer,
		CashInBankDisplayer,
		CashFlowDisplayer,
		CashInDisplayer,
		CashOutDisplayer,
		TodayCustomerDueTable,
		TodaySupplierDueTable,
	},
})
export default class Dashboard extends BaseReport {
  public id: any = '';
	public selectedDay: number = moment().endOf('day').valueOf();

	public get selectedDateRange() {
		return [
			moment(this.selectedDay).startOf('month').valueOf(),
			moment(this.selectedDay).endOf('day').valueOf(),
		];
	}

	public get selectedAgents(): string[] {
		return gdbx.allAgents.map((item) => item.value);
	}

	public get selectedCustomers(): string[] {
		return gdbx.allCustomers.map((item) => item.value);
	}

	public get selectedAsOfDate() {
		return moment(this.selectedDay).endOf('day').valueOf();
	}

	public mounted() {
    this.id = accountx.currentAccountId;
		  this.track();

		  if (accountx.currentAccountId === 'HsJ2Zj1jFkQVkxOKmxvk') {
			this.$router.push('/account/' + accountx.currentAccountId + '/dealer');
		}
	}

	public track() {
		this.$ga.set('userId', userx.user!.uid + '_' + userx.user!.email);
		this.$ga.page(router);
	}
}
